/**
 @Developper: BenAli Faker
 @Company: SMART-INFO
 @Post: CTO
 @Date:21/12/2020
 @Time:21:42
 **/
import User from "../../user/model/User";
import VenteLigneBase from "./VenteLigneBase";
import VenteLigneProduit from "./VenteLigneProduit";
import VenteLigneProduitPaquet from "./VenteLigneProduitPaquet";
import PaiementLigneBase from "../../paiement/modele/PaiementLigneBase";
import PaiementLigneCheque from "../../paiement/modele/PaiementLigneCheque";
import Societe from "../../societe/model/Societe";
import LangueService from "../../../i18n/service/LangueService";
import PaiementLigneEspece from "../../paiement/modele/PaiementLigneEspece";
import ProduitPaquet from "../../produit/modele/ProduitPaquet";
import Produit from "../../produit/modele/Produit";
import CalculUtil from "../../util/CalculUtil";
import PersonneClient from "../../societe/model/PersonneClient";
import SocieteClient from "../../societe/model/SocieteClient";

export default class Vente {

    /**
     * les types client ou fournisseur pour une vete
     * @type {Readonly<{EXISTANT: string, ANONYME: string, COMPTOIR: string}>}
     */
    static CLIENT_FOURNISSEUR_TYPE=Object.freeze({'ANONYME':'ANONYME','EXISTANT':'EXISTANT','COMPTOIR':'COMPTOIR'})


    /**
     *  les types de numerotation d'une facture associée a une vente ou achat
     * @type {Readonly<{AUCUNE_NUMEROTATION: string, AUTO_GENEREE: string, MANUELLE: string}>}
     */
    static NUMEROTATION_TYPE=Object.freeze({'AUCUNE_NUMEROTATION':'AUCUNE_NUMEROTATION','AUTO_GENEREE':'AUTO_GENEREE','MANUELLE':'MANUELLE'})

    /**
     * dernier id temporaire affecté a une vente (pour les ventes encours de creation)
     * @type {number}
     */
    static #lastVenteTemporaireID=0;

    /**
     * @type{string}
     */
    #_id;


    /**
     * @type{boolean}
     */
    #_temporaire = true;

    /**
     * indique si la vente est facturable ou non
     * @type {boolean}
     */
    #_facturable =false;


    /**
     * @type {?string} le type de client/fournisseur (anonyme,comptoir,existant dans le système)
     */
    #_clientOuFournisseurType=null;

    /**
     *
     * @type  {Object<String,VenteLigneProduit>}
     */
    #_venteLigneProduitList = {}

    /**
     *
     * @type {Object<String,VenteLigneProduitPaquet>}
     */
    #_venteLigneProduitPaquetList = {};


    /**
     * @type{Object<String,PaiementLigneBase>}
     */
    #_paiementLigneList={};



    /**
     * @type{string} le numéro de la vente / Achat
     */
    #_numero;

    /**
     * le type de numéro (généré par le système ou externe
     * @type{string}
     */
    #_numeroVenteOuAchatType;

    /**
     * date de la facture
     * @type{Date}
     */
    #_date;

    /**
     * @type{String} registre de commerce de vendeur
     */
    #_registreCommerceAcheteur;

    /**
     * @type{string} matricule fiscale de l'acheteur
     */
    #_matriculeFiscaleAcheteur;

    /**
     *
     * @type{string} téléphone de l'acheteur
     */
    #_telephoneAcheteur;


    /**
     * @type{String} registre de commerce du vendeur
     */
    #_registreCommerceVendeur;

    /**
     * @type{string} matricule fiscale du vendeur
     */
    #_matriculeFiscaleVendeur;

    /**
     *
     * @type{string} téléphone du vendeur
     */
    #_telephoneVendeur;

    /**
     * adresse de l'acheteur
     * @type {Object<string,string>}
     * @private
     */
    #_adresseAcheteur = {};

    /**
     * nom de l'acheteur
     * @type {Object<string,string>}
     * @private
     */
    #_nomAcheteur = {};

    /**
     * prénom de l'acheteur
     * @type {Object<string,string>}
     * @private
     */
    #_prenomAcheteur = {};

    /**
     *
     * @type {Object<string,string>}
     * @private
     */
    #_nomCommercialAcheteur = {};

    /**
     * adresse du vendeur
     * @type {Object<string,string>}
     * @private
     */
    #_adresseVendeur = {};

    /**
     * nom du vendeur
     * @type {Object<string,string>}
     * @private
     */
    #_nomVendeur = {};

    /**
     * prénom du vendeur
     * @type {Object<string,string>}
     * @private
     */
    #_prenomVendeur = {};

    /**
     *
     * @type {Object<string,string>}
     * @private
     */
    #_nomCommercialVendeur = {};


    /**
     * @type {Societe} acheteur si le client est un utilisateur begro
     */
    #_acheteur = null;

    /**
     * @type{Societe} le vendeur si le vendeur est un utilisateur begro
     */
    #_vendeur = null;

    /**
     * marqué comme supprimé pour le vendeur
     * @type {boolean}
     * @private
     */
    #_supprimeV = false;

    /**
     * indique si la vente est une vente service ou commerce
     * @type {boolean}
     * @private
     */
    #_service=false;


    /**
     * marqué comme supprimé pour l'acheteur
     * @type {boolean}
     * @private
     */
    #_supprimeA = false;

    /**
     * @type {User} utilisateur qui crée vente ou achat
     */
    #_creeParUser;

    /**
     * @type{string} status qui indique que la vente / achat est totalement payé ou non
     */
    #_paiementStatus;

    /**
     * Montant totale de la vente/achat hors taxe
     * @type {number}
     */
    #_montantTotal = 0;

    /**
     * Totale des taxes
     * @type {number}
     * @private
     */
    #_taxes = 0;


    /**
     * montant tout taxe comprise
     * @type {number}
     * @private
     */
    #_montantTotalTTC = 0;

    /**
     * Le montant paye de la vente/achat
     * @type {number}
     * @private
     */
    #_montantPaye = 0;

    /**
     * Le montant comptant paye de la vente/achat
     * @type {number}
     * @private
     */
    #_montantPayeComptant = 0;

    /**
     * nombre totale des produits vendus
     * @type {number}
     * @private
     */
    #_nbProduitVendu = 0;

    /**
     * @type{BonSortie}// bon sortie attaché a la vente si l'utilisateur connecté ou qu'il la crée est un vendeur externe
     */
    #_bonSortie = null;

    /**
     * si le paiement des motant sera faite par tranche
     * @type {boolean}
     * @private
     */
    #_paiementComptant = true;

    /**
     * Le timbre fiscal appliqué
     * @type {number}
     * @private
     */
    #_timbreFiscal=0.600;

    /**
     *
     * @type {Object<String,VenteLigneBase>}
     * @private
     */
    #_venteLigneList={};


    get clientOuFournisseurType() {
        return this.#_clientOuFournisseurType;
    }

    set clientOuFournisseurType(value) {
        this.#_clientOuFournisseurType = value;
    }

    /**
     * Ajoute le nom du vendeur dans la langue choisie
     * @param {string} locale
     * @param {string} nom
     */
    addVendeurNom(locale, nom) {
        this.#_nomVendeur[locale] = nom;
    }




    get montantPayeComptant() {
        return this.#_montantPayeComptant;
    }

    set montantPayeComptant(value) {
        this.#_montantPayeComptant = value;
    }

    /**
     * ajoute le prenom du vendeur traduit a la langue eéçu en paramètre
     * @param {string}locale
     * @param {string}prenom
     */
    addVendeurPrenom(locale, prenom) {
        this.#_prenomVendeur[locale] = prenom;
    }

    /**
     * Ajoute une adresse traduit pour le vendeur
     * @param {string}locale
     * @param {string} adresse
     */
    addVendeurAdresse(locale, adresse) {
        this.#_adresseVendeur[locale] = adresse;
    }

    /**
     * Ajoute le nom commercial traduit pour le vendeur
     * @param {string}locale
     * @param {string} adresse
     */
    addVendeurNomCommercial(locale, adresse) {
        this.#_nomCommercialVendeur[locale] = adresse;
    }


    get timbreFiscal() {
        return this.#_timbreFiscal;
    }

    set timbreFiscal(value) {
        this.#_timbreFiscal = value;
    }


    get service() {
        return this.#_service;
    }

    set service(value) {
        this.#_service = value;
    }

    get facturable() {
        return this.#_facturable;
    }

    set facturable(value) {
        if( this.#_clientOuFournisseurType!=null)
        {
            this.updateTvaEtPrix(this.#_facturable,value);
        }
        this.#_facturable = value;
    }

    /**
     * retourne le nom commercial traduit pour le vendeur
     * @param {string}locale
     */
    getVendeurNomCommercial(locale) {
        this.#_nomCommercialVendeur[locale] = adresse;
    }

    /**
     *
     * @param locale
     * @return {string} retourne le nom du vendeur dans la langue réçu
     */
    getVendeurNom(locale) {
        return this.#_nomVendeur[locale] !== undefined ? this.#_nomVendeur[locale] : '';
    }

    /**
     *
     * @param locale
     * @return {string} retourne le prénom du vendeur dans la langue rèçu
     */
    getVendeurPrenom(locale) {
        return this.#_prenomVendeur[locale] !== undefined ? this.#_prenomVendeur[locale] : '';
    }

    /**
     *
     * @param locale
     * @return {string} adresse du vendeur dans la langue réçu en paramètre
     */
    getVendeurAdresse(locale) {
        return this.#_adresseVendeur[locale] !== undefined ? this.#_adresseVendeur[locale] : '';
    }

    /**
     * Ajoute le nom commercial traduit pour l'acheteur
     * @param {string}locale
     * @param {string} adresse
     */
    addAcheteurNomCommercial(locale, adresse) {
        this.#_nomCommercialAcheteur[locale] = adresse;
    }


    /**
     * retourne le nom commercial traduit pour l'acheteur
     * @param {string}locale
     */
    getAcheteurNomCommercial(locale) {
        this.#_nomCommercialAcheteur[locale] = adresse;
    }


    /**
     * Ajoute le nom de l'acheteur dans la langue choisie
     * @param {string} locale
     * @param {string} nom
     */
    addAcheteurNom(locale, nom) {
        this.#_nomAcheteur[locale] = nom;
    }

    /**
     * ajoute le prenom de l'acheteur traduit a la langue réçu en paramètre
     * @param {string}locale
     * @param {string}prenom
     */
    addAcheteurPrenom(locale, prenom) {
        this.#_prenomAcheteur[locale] = prenom;
    }

    /**
     * Ajoute une adresse traduit pour l'acheteur
     * @param {string}locale
     * @param {string} adresse
     */
    addAcheteurAdresse(locale, adresse) {
        this.#_adresseAcheteur[locale] = adresse;
    }

    /**
     *
     * @param locale
     * @return {string} retourne le nom de l'acheteur dans la langue réçu
     */
    getAcheteurNom(locale) {
        return this.#_nomAcheteur[locale] !== undefined ? this.#_nomAcheteur[locale] : '';
    }

    /**
     *
     * @param locale
     * @return {string} retourne le prénom de l'acheteur dans la langue rèçu
     */
    getAcheteurPrenom(locale) {
        return this.#_prenomAcheteur[locale] !== undefined ? this.#_prenomAcheteur[locale] : '';
    }

    /**
     *
     * @param locale
     * @return {string} adresse de l'acheteur dans la langue réçu en paramètre
     */
    getAcheteurAdresse(locale) {
        return this.#_adresseAcheteur[locale] !== undefined ? this.#_adresseAcheteur[locale] : '';
    }



    get paiementComptant() {
        return this.#_paiementComptant;
    }

    set paiementComptant(value) {
        this.#_paiementComptant = value;
    }

    get numero() {
        return this.#_numero;
    }

    set numero(value) {
        this.#_numero = value;
    }

    get numeroFactureType() {
        return this.#_numeroVenteOuAchatType;
    }

    set numeroFactureType(value) {
        this.#_numeroVenteOuAchatType = value;
    }

    get date() {
        return this.#_date;
    }

    set date(value) {
        this.#_date = value;
    }

    get registreCommerceAcheteur() {
        return this.#_registreCommerceAcheteur;
    }

    set registreCommerceAcheteur(value) {
        this.#_registreCommerceAcheteur = value;
    }

    get matriculeFiscaleAcheteur() {
        return this.#_matriculeFiscaleAcheteur;
    }

    set matriculeFiscaleAcheteur(value) {
        this.#_matriculeFiscaleAcheteur = value;
    }

    get telephoneAcheteur() {
        return this.#_telephoneAcheteur;
    }

    set telephoneAcheteur(value) {
        this.#_telephoneAcheteur = value;
    }

    get registreCommerceVendeur() {
        return this.#_registreCommerceVendeur;
    }

    set registreCommerceVendeur(value) {
        this.#_registreCommerceVendeur = value;
    }

    get matriculeFiscaleVendeur() {
        return this.#_matriculeFiscaleVendeur;
    }

    set matriculeFiscaleVendeur(value) {
        this.#_matriculeFiscaleVendeur = value;
    }

    get telephoneVendeur() {
        return this.#_telephoneVendeur;
    }

    set telephoneVendeur(value) {
        this.#_telephoneVendeur = value;
    }

    get acheteur() {
        return this.#_acheteur=null;
    }

    set acheteur(value) {
        this.#_acheteur = value;
    }

    get vendeur() {
        return this.#_vendeur=null;
    }

    set vendeur(value) {
        this.#_vendeur = value;
    }

    get supprimeV() {
        return this.#_supprimeV;
    }

    set supprimeV(value) {
        this.#_supprimeV = value;
    }

    get supprimeA() {
        return this.#_supprimeA;
    }

    set supprimeA(value) {
        this.#_supprimeA = value;
    }

    get creeParUser() {
        return this.#_creeParUser;
    }

    set creeParUser(value) {
        this.#_creeParUser = value;
    }

    get paiementStatus() {
        return this.#_paiementStatus;
    }

    set paiementStatus(value) {
        this.#_paiementStatus = value;
    }

    get montantTotal() {
        return this.#_montantTotal;
    }

    set montantTotal(value) {
        this.#_montantTotal = value;
    }

    get taxes() {
        return this.#_taxes;
    }

    set taxes(value) {
        this.#_taxes = value;
    }

    get montantTotalTTC() {
        return this.#_montantTotalTTC;
    }

    set montantTotalTTC(value) {
        this.#_montantTotalTTC = value;
    }

    get montantPaye() {
        return this.#_montantPaye;
    }

    set montantPaye(value) {
        this.#_montantPaye = value;
    }

    get nbProduitVendu() {
        return this.#_nbProduitVendu;
    }

    set nbProduitVendu(value) {
        this.#_nbProduitVendu = value;
    }

    get bonSortie() {
        return this.#_bonSortie;
    }

    set bonSortie(value) {
        this.#_bonSortie = value;
        let activeLocale=LangueService.getInstance().activeLangue.locale;
        //attachement du bon sortie ligne produit paquet et produit  au ligne vente produit et produit paquet
        for(let produitID in this.#_venteLigneProduitList)
        {
            let venteLigneProduit=this.#_venteLigneProduitList[produitID];
            venteLigneProduit.bonSortieLigneProduit=this.#_bonSortie.getBonSortieLigneProduit(produitID);
             Begro.logInfo("Attachement bon sortie ligne produit - "+venteLigneProduit.bonSortieLigneProduit.getDesignation(activeLocale)+" -"+"pour la ligne de vente produit ayant l'id"+venteLigneProduit.id)

        }
        for(let produitPaquetID in this.#_venteLigneProduitPaquetList)
        {
            let venteLigneProduitPaquet=this.#_venteLigneProduitPaquetList[produitPaquetID];
            venteLigneProduitPaquet.bonSortieLigneProduitPaquet=this.#_bonSortie.getBonSortieLigneProduitPaquet(produitPaquetID);
            Begro.logInfo("Attachement bon sortie ligne produit paquet - "+venteLigneProduitPaquet.bonSortieLigneProduitPaquet.getDesignation(activeLocale)+" -"+"pour la ligne de vente produit paquet ayant l'id"+venteLigneProduitPaquet.id);

        }
    }


    /**
     * Générer  un nouveau identifiant unique temporaire pour une vente en cours de construction
     * @return {string}
     */
    static generateNouvelleVenteTemporaireID(){
        let nouveauIDTemporaire="vente-ligne-temporaire-"+Vente.#lastVenteTemporaireID;
        Vente.#lastVenteTemporaireID++;
        return nouveauIDTemporaire;
    }



    /**
     * Ajoute une ligne vente produit
     * @param {VenteLigneProduit} venteLigneProduit
     */
    addVenteLigneProduit(venteLigneProduit) {
        if(typeof venteLigneProduit.produit!="undefined") {
            this.#_venteLigneProduitList[venteLigneProduit.produit.id] = venteLigneProduit;
        }
        this.#_venteLigneList[venteLigneProduit.id]=venteLigneProduit;
    }

    /**
     * remove une ligne vente produit
     * @param {string|Produit} produit produit qu'on veut supprimer la ligne bon de sortie qui lui est associé
     */
    removeVenteLigneProduit(produit) {
        let id = produit instanceof Produit ? produit.id : produit;
        if(this.#_venteLigneProduitList[id]!==undefined)
        {
            delete this.#_venteLigneList[this.#_venteLigneProduitList[id].id];
            delete this.#_venteLigneProduitList[id]
        }
    }

    /**
     * Ajoute une ligne vente produitPaquet
     * @param {VenteLigneProduitPaquet} venteLigneProduitPaquet
     */
    addVenteLigneProduitPaquet(venteLigneProduitPaquet) {
        if(typeof venteLigneProduitPaquet.produitPaquet!="undefined") {
            this.#_venteLigneProduitPaquetList[venteLigneProduitPaquet.produitPaquet.id] = venteLigneProduitPaquet;
        }
        this.#_venteLigneList[venteLigneProduitPaquet.id]=venteLigneProduitPaquet;
    }

    /**
     * remove une ligne vente produit paquet
     * @param {string|ProduitPaquet} produitPaquet produit qu'on veut supprimer la ligne bon de sortie qui lui est associé
     */
    removeVenteLigneProduitPaquet(produitPaquet) {
        let id = produitPaquet instanceof ProduitPaquet ? produitPaquet.id : produitPaquet;
        if(this.#_venteLigneProduitPaquetList[id] !== undefined)
        {
            delete this.#_venteLigneList[this.#_venteLigneProduitPaquetList[id].id];
            delete this.#_venteLigneProduitPaquetList[id];

        }
    }

    /**
     * retourne vente ligne par its id si elle existe
     * @param id
     * @return {null|VenteLigneBase}
     */
    getVenteLigneByID(id){
        if(this.#_venteLigneList[id]!==undefined){
            return this.#_venteLigneList[id];
        }
        return null;
    }


    /**
     * Méthode qui retourne les lignes vente produit pur une vente
     * @return @return {Object<String,VenteLigneProduit>}
     */
    get venteLigneProduitList() {
        return this.#_venteLigneProduitList;
    }

    /**
     * Méthode qui retourne les lignes vente produit paquet pour une vente
     * @return {Object<String,VenteLigneProduitPaquet>}
     */
    get venteLigneProduitPaquetList() {
        return this.#_venteLigneProduitPaquetList;
    }

    /**
     *
     * @param {ProduitPaquet|string} produitPaquet
     * @return {VenteLigneProduitPaquet|string}
     */
    getVenteLigneProduitPaquet(produitPaquet)
    {
        let id=produitPaquet instanceof ProduitPaquet?produitPaquet.id:produitPaquet;
        return this.#_venteLigneProduitPaquetList[id]!==undefined?this.#_venteLigneProduitPaquetList[id]:null;
    }

    /**
     *
     * @param {Produit|string} produit
     * @return {VenteLigneProduit|string}
     */
    getVenteLigneProduit(produit)
    {
        let id=produit instanceof Produit?produit.id:produit;
        return this.#_venteLigneProduitList[id]!==undefined?this.#_venteLigneProduitList[id]:null;
    }



    /**
     * Ajoute une ligne paiement
     * @param {PaiementLigneBase} paiementLigneBase
     */
    addLignePaiement(paiementLigneBase){
        this.#_paiementLigneList[paiementLigneBase.id]=paiementLigneBase;
    }

    /**
     * Supprime une ligne de paiement si elle existe
     * @param {PaiementLigneBase}paiementLigneBase
     */
    removeLignePaiement(paiementLigneBase){
        this.#_paiementLigneList[paiementLigneBase.id]!==undefined?delete this.#_paiementLigneList[paiementLigneBase.id]:null;
    }

    get id() {
        return this.#_id;
    }

    set id(value) {
        this.#_id = value;
    }

    get temporaire() {
        return this.#_temporaire;
    }

    set temporaire(value) {
        this.#_temporaire = value;
    }

    /**
     * méthode qui vérifie si une ligne est déja ajouté a la vente / achat
     * @param {string|Produit} produit
     */
    isLigneProduitAjoute(produit) {
        let id = produit instanceof Produit ? produit.id : id;
        return this.#_venteLigneProduitList[id] !== undefined;
    }

    /**
     * indique si une ligne produit paquet est ajouté ou non
     * @param {string|ProduitPaquet}produitPaquet
     * @return {boolean}
     */
    isLigneProduitPaquetAjoute(produitPaquet) {
        let id = produitPaquet instanceof ProduitPaquet ? produitPaquet.id : id;
        return this.#_venteLigneProduitPaquetList[id] !== undefined;
    }

    /**
     * Retourne le nombre des lignes ventes trouvés pour la vente
     * @return {number}
     */
    getNombreLigneVente(){
        return Object.keys(this.#_venteLigneProduitList).length+Object.keys(this.#_venteLigneProduitPaquetList).length;
    }

    /**
     * Le montant totale des tranches de paiement
     * @return {number}
     */
    getTotaleTranchePaiement(){
        let montantTotalTanches=0;
        for(let index in this.#_paiementLigneList){
            montantTotalTanches+=this.#_paiementLigneList[index].montant;
        }
        return montantTotalTanches;
    }

    /**
     * retourne le tranche de paiement ayant id rèçu en paramètre si elle est trouvé
     * @param {string} id id tranche de paiement qu'on veut récupérer
     * @return {PaiementLigneBase} ligne de paiement ayant id rèçu en paramètre
     */
    getPaiementLigne(id){
        return this.#_paiementLigneList[id]!==undefined?this.#_paiementLigneList[id]:null;
    }

    /**
     * Retourne le nombre des lignes de tranche de paiement pour une vente
     * @return {number}
     */
    getNombreLigneTranchePaiement(){
        return Object.keys(this.#_paiementLigneList).length;
    }

    /**
     * Le montant totale pour les tranches de paiement
     * @return {number}
     */
    getMontantTotaleLignesPaiement(){
        let montantTotalLignes=0;
        for(let index in this.#_paiementLigneList)
        {
            montantTotalLignes+=this.#_paiementLigneList[index].montant;
        }
        return montantTotalLignes;
    }


    get venteLigneList() {
        return this.#_venteLigneList;
    }

    /**
     * méthode de classe qui permet de céer un nouveau objet vente depuis un json généré depuis objet vente java
     * @param {{}} venteJson
     * @returns {Vente}
     */
    static creatObjetFromJson(venteJson,venteMode="vente") {
        let activeLocale=LangueService.getInstance().activeLangue.locale;
        let vente = Begro.getVente(venteJson.id);
        if(!vente) {
            vente=new Vente();
            if (!venteJson.id) {
                vente.id=Vente.generateNouvelleVenteTemporaireID();
            }else{
                vente.temporaire = false;
                vente.id=venteJson.id;
            }
            vente.clientOuFournisseurType = venteMode==="vente"?venteJson.acheteurType:venteJson.vendeurType ;
            vente.numero = venteJson.numero;
            vente.numeroFactureType = venteJson.numeroFactureType;
            vente.date = new Date(venteJson.date);
            vente.registreCommerceVendeur = venteJson.registreCommerceVendeur;
            vente.matriculeFiscaleAcheteur = venteJson.matriculeFiscaleAcheteur;
            vente.telephoneAcheteur = venteJson.telephoneAcheteur;
            vente.registreCommerceAcheteur = venteJson.registreCommerceAcheteur;
            vente.matriculeFiscaleVendeur = venteJson.matriculeFiscaleVendeur;
            vente.facturable=venteJson.facturable;
            //todo ajoute la creation du vendeur de type societe
            //todo ajoute la creation du acheteur ligne
            vente.supprimeA = venteJson.supprimeA;
            vente.supprimeV = venteJson.supprimeV;
            vente.timbreFiscal = venteJson.timbreFiscal;
            //todo ajouter ligne cree par la société
            vente.creeParUser = User.createFromUserJson(venteJson.creeParUser);
            vente.paiementComptant = venteJson.paiementComptant;
            vente.paiementStatus = venteJson.paiementStatus;
            vente.montantTotal = venteJson.montantTotal;
            vente.taxes = venteJson.taxes;
            vente.service=venteJson.service;
            vente.montantPayeComptant = venteJson.montantPayeComptant;
            vente.montantTotalTTC = venteJson.montantTotalTTC;
            vente.montantPaye = venteJson.montantPaye;
            vente.nbProduitVendu = venteJson.nbProduitVendu;
            vente.vendeur=venteJson.vendeur!==null?Societe.creatObjetFromJson(venteJson.vendeur):null;
            vente.acheteur=venteJson.acheteur!==null?(venteJson.acheteur.type="personne"?PersonneClient.createObjectFromJson(venteJson.acheteur,null):SocieteClient.createObjectFromJson(venteJson.acheteur,null)):null;
            if(venteJson.hasOwnProperty("venteLigneList")) {
                for (let index in venteJson.venteLigneList) {
                    let venteLigneJson = venteJson.venteLigneList[index];
                    if (venteLigneJson.discriminator === "produit") {
                        let venteLigneProduit = VenteLigneProduit.createObjetFromJson(venteLigneJson);
                        vente.addVenteLigneProduit(venteLigneProduit);
                        venteLigneProduit.vente = vente;
                        Begro.logInfo("Ajout ligne vente produit pour le produit " + venteLigneProduit.getDesignation(activeLocale));
                    } else {
                        let venteLigneProduitPaquet = VenteLigneProduitPaquet.createObjetFromJson(venteLigneJson);
                        venteLigneProduitPaquet.vente = vente;
                        vente.addVenteLigneProduitPaquet(venteLigneProduitPaquet);
                        Begro.logInfo("Ajout ligne vente produit paquet pour le produit  " + venteLigneProduitPaquet.getDesignation(activeLocale));
                    }
                }
            }
            if(venteJson.hasOwnProperty("traductions")) {
                for (let locale in venteJson.traductions) {
                    let ligneTraductionJson = venteJson.traductions[locale];
                    vente.addAcheteurAdresse(locale, ligneTraductionJson['acheteurAdresse']);
                    vente.addAcheteurNom(locale, ligneTraductionJson['acheteurNom']);
                    vente.addAcheteurPrenom(locale, ligneTraductionJson['acheteurPrenom']);
                    vente.addVendeurAdresse(locale, ligneTraductionJson['vendeurAdresse']);
                    vente.addVendeurNom(locale, ligneTraductionJson['vendeurNom']);
                    vente.addVendeurPrenom(locale, ligneTraductionJson['vendeurPrenom']);
                    vente.addAcheteurNomCommercial(locale, ligneTraductionJson['nomCommercialAcheteur']);
                    vente.addVendeurNomCommercial(locale, ligneTraductionJson['nomCommercialVendeur'])
                }
            }
            //ajouter les lignes de paiement si le paiement n'est pas comptant
            if(!vente.paiementComptant && venteJson.hasOwnProperty("paiementLignes")){
                for(let index in venteJson.paiementLignes)
                {
                    let lignePaiementJson=venteJson.paiementLignes[index];
                    let lignePaiement=(lignePaiementJson.discriminator==='espece')?PaiementLigneEspece.createFromJson(lignePaiementJson):PaiementLigneCheque.createFromJson(lignePaiementJson);
                    lignePaiement.vente=vente;
                    vente.addLignePaiement(lignePaiement);
                    Begro.logInfo("Ligne de paiement ("+lignePaiementJson.type+") avec id "+lignePaiement.id+" a été ajouté à la vente ayant id "+vente.id);
                }
            }
            if (venteJson.bonSortie !== null) {
                vente.bonSortie = BonSortie.creatObjetFromJson(venteJson.bonSortie);
                //attacher les lignes vente et sa correspondance sur le bon de sortie
                for(let id in vente.venteLigneProduitPaquetList)
                {
                    let venteLigneProduitPaquet=vente.venteLigneProduitPaquetList[id];
                    venteLigneProduitPaquet.bonSortieLigneProduitPaquet=vente.bonSortie.getBonSortieLigneProduitPaquet(id);
                }
                for(let id in vente.venteLigneProduitList)
                {
                    let venteLigneProduit=vente.venteLigneProduitList[id];
                    venteLigneProduit.bonSortieLigneProduit=vente.bonSortie.getBonSortieLigneProduit(id);
                }
            }
            Begro.addVente(vente);
            Begro.logInfo("Le vente ayant l'id "+vente.id+" a été crée et  ajouté  au conteneur Begro");
        }else{
            Begro.logInfo("Le vente ayant id "+vente.id+" a été retiré depuis le conteneur Begro");
        }
        return vente;
    }

    /**
     * indique si la vente/achat et vendu ou acheté a partir d'un anonyme
     * @return {boolean}
     */
    isVenteAnonyme(){
        return this.clientOuFournisseurType===Vente.CLIENT_FOURNISSEUR_TYPE.ANONYME;
    }

    /**
     * mettre a jour le prix ttc et taxe selon la vente est facturable ou non
     * @param {boolean} oldFacturableFieldValue
     * @param {boolean} nouveauFacturableFieldValue
     */
    updateTvaEtPrix(oldFacturableFieldValue , nouveauFacturableFieldValue){
            Begro.logInfo(`update ligne tva et prix aprés changement du  fatcturable  de ${oldFacturableFieldValue} vers ${nouveauFacturableFieldValue}`);
            let taxePrecedent;
            for (let i in this.venteLigneList) {
                let venteLigne = this.venteLigneList[i]
                taxePrecedent = venteLigne.taxe;
                if (venteLigne instanceof VenteLigneProduit) {
                    venteLigne.taxe = !nouveauFacturableFieldValue ? 0 : venteLigne.produit.taxe;
                } else {
                    if (venteLigne instanceof VenteLigneProduitPaquet) {
                        venteLigne.taxe =  !nouveauFacturableFieldValue  ? 0 : venteLigne.produitPaquet.produit.taxe;
                    }
                }

                if ( !oldFacturableFieldValue) { //le montant ttc précédant était un montant hors taxes puisque taxe était 0%
                    venteLigne.prixTTC =CalculUtil.prixTTC(venteLigne.prixTTC , venteLigne.taxe);
                } else {//
                      venteLigne.prixTTC = CalculUtil.calculateNewPriceTTC(venteLigne.prixTTC,taxePrecedent,venteLigne.taxe);
                }
            }
    }



    /**
     * Recalculer le total hors taxes et le total TTC
     */
    recalculerTotaleVente(){
         this.#_montantTotal=0;
         this.#_montantTotalTTC=0;
         for(let id in this.#_venteLigneProduitList)
         {
             this.#_montantTotal+=this.#_venteLigneProduitList[id].getPrixTotaleHTTC();
             this.#_montantTotalTTC+=this.#_venteLigneProduitList[id].getPrixTotaleTTC();
         }
         for(let id in this.#_venteLigneProduitPaquetList)
         {
             this.#_montantTotalTTC+=this.#_venteLigneProduitPaquetList[id].getPrixTotaleTTC();
             this.#_montantTotal+=this.#_venteLigneProduitPaquetList[id].getPrixTotaleHTTC();
         }
        this.#_taxes=this.#_montantTotalTTC-this.#_montantTotal;// la totale des taxes
        this.#_montantTotalTTC+=this.#_timbreFiscal;
        if(this.paiementComptant){
            this.montantPaye=this.#_montantTotalTTC;
        }
    }


}